import { useAuth } from '../auth';
import buildNav from '../navConfig';
import PrimaryNav from './PrimaryNav';

export default function Header() {
  const { user, isAuthenticated } = useAuth();
  const has = (r) => isAuthenticated && (user.role === r || (user.roles || []).includes(r));
  const nav = buildNav({ user, isAuthenticated, has });
  return <PrimaryNav nav={nav} isAuthenticated={isAuthenticated} />;
}
